var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.dialogLoading,
                      expression: "dialogLoading",
                    },
                  ],
                  ref: "refCityForm",
                  staticClass: "demo-cityForm",
                  attrs: {
                    "label-width": "170px",
                    model: _vm.cityForm,
                    rules: _vm.cityRules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "城市仓名称", prop: "name" } },
                    [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入城市仓名称",
                              clearable: "",
                              disabled: _vm.closeDisable,
                            },
                            model: {
                              value: _vm.cityForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.cityForm, "name", $$v)
                              },
                              expression: "cityForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "集配业务中心", prop: "business_id" } },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: _vm.closeDisable,
                                placeholder: "选择业务中心",
                              },
                              on: { change: _vm.changeBusinessId },
                              model: {
                                value: _vm.cityForm.business_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "business_id", $$v)
                                },
                                expression: "cityForm.business_id",
                              },
                            },
                            _vm._l(_vm.logisticsList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                                nativeOn: {
                                  click: function ($event) {
                                    _vm.morning_time = item.morning_time
                                  },
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "城市仓类型", prop: "logistics_type" } },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: _vm.isEdit || _vm.closeDisable,
                                clearable: "",
                                placeholder: "选择城市仓类型",
                              },
                              on: { change: _vm.changeLogisticsType },
                              model: {
                                value: _vm.cityForm.logistics_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "logistics_type", $$v)
                                },
                                expression: "cityForm.logistics_type",
                              },
                            },
                            _vm._l(_vm.logisticsTypeList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.isEdit
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "自提点数量",
                            prop: "delivery_number",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "请输入自提点数量",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.cityForm.delivery_number,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.cityForm,
                                      "delivery_number",
                                      $$v
                                    )
                                  },
                                  expression: "cityForm.delivery_number",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "截单时间", prop: "dateTime" } },
                    [
                      _c("div", { staticClass: "d-flex a-center" }, [
                        _c("div", { staticClass: "d-flex a-center" }, [
                          _c(
                            "div",
                            [
                              _c("el-time-picker", {
                                attrs: {
                                  disabled: _vm.closeDisable,
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  placeholder: "开始时间",
                                },
                                model: {
                                  value: _vm.cityForm.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "startTime", $$v)
                                  },
                                  expression: "cityForm.startTime",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", [_vm._v("—")]),
                          _c(
                            "div",
                            [
                              _c("el-time-picker", {
                                attrs: {
                                  disabled: _vm.closeDisable,
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  placeholder: "结束时间",
                                },
                                model: {
                                  value: _vm.cityForm.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "endTime", $$v)
                                  },
                                  expression: "cityForm.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticStyle: { "margin-left": "20px" } },
                          [
                            _vm._v(" " + _vm._s(_vm.Timename()) + " "),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: _vm.titlename(),
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#000" },
                                    attrs: { type: "text" },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning-outline",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  [
                    _c("el-form-item", { attrs: { label: "账号昵称" } }, [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入账号昵称",
                              clearable: "",
                              disabled: _vm.closeDisable,
                            },
                            model: {
                              value: _vm.cityForm.nickname,
                              callback: function ($$v) {
                                _vm.$set(_vm.cityForm, "nickname", $$v)
                              },
                              expression: "cityForm.nickname",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "登录账号", prop: "account_number" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  placeholder: "请输入登录账号",
                                  clearable: "",
                                  disabled: _vm.isEdit || _vm.closeDisable,
                                },
                                model: {
                                  value: _vm.cityForm.account_number,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.cityForm,
                                      "account_number",
                                      $$v
                                    )
                                  },
                                  expression: "cityForm.account_number",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "suffix",
                                      type: "text",
                                      disabled:
                                        !_vm.businessUserId || _vm.closeDisable,
                                    },
                                    on: { click: _vm.onHandleResetPassword },
                                    slot: "suffix",
                                  },
                                  [_vm._v("重置密码")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    !_vm.isEdit
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "密码", prop: "password" } },
                          [
                            _c(
                              "div",
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "password",
                                    disabled: _vm.closeDisable,
                                    placeholder: "请输入密码",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.cityForm.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.cityForm, "password", $$v)
                                    },
                                    expression: "cityForm.password",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客服电话", prop: "service_mobile" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: 11,
                                disabled: _vm.closeDisable,
                                placeholder: "请输入客服电话",
                                clearable: "",
                              },
                              model: {
                                value: _vm.cityForm.service_mobile,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "service_mobile", $$v)
                                },
                                expression: "cityForm.service_mobile",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "提现银行卡", prop: "card_code" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.closeDisable || _vm.isEdit,
                                placeholder: "请输入提现银行卡",
                                clearable: "",
                              },
                              model: {
                                value: _vm.cityForm.card_code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "card_code", $$v)
                                },
                                expression: "cityForm.card_code",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属银行", prop: "bank_code" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  disabled: _vm.closeDisable || _vm.isEdit,
                                  placeholder: "选择所属银行",
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.depositList = []
                                    _vm.cityForm.bank_deposit = ""
                                  },
                                },
                                model: {
                                  value: _vm.cityForm.bank_code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "bank_code", $$v)
                                  },
                                  expression: "cityForm.bank_code",
                                },
                              },
                              _vm._l(_vm.bankList, function (item) {
                                return _c("el-option", {
                                  key: item.bank_code,
                                  attrs: {
                                    label: item.bank_name,
                                    value: item.bank_code,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.cityForm.bank_name = item.bank_name
                                    },
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "开户行", prop: "bank_deposit" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.closeDisable || _vm.isEdit,
                                  "remote-method": _vm.ajaxGetBranchList,
                                  loading: _vm.depositLoading,
                                  clearable: "",
                                  filterable: "",
                                  remote: "",
                                  placeholder: "选择开户行",
                                },
                                model: {
                                  value: _vm.cityForm.bank_deposit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "bank_deposit", $$v)
                                  },
                                  expression: "cityForm.bank_deposit",
                                },
                              },
                              _vm._l(_vm.depositList, function (item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: item.branch_name,
                                    value: item.branch_name,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.cityForm.deposit_code = item.code
                                    },
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "持卡人身份证国徽页",
                          prop: "idcard_a",
                        },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.uploadLoading,
                                expression: "uploadLoading",
                              },
                            ],
                            class: {
                              hide: _vm.idcard_a.length || !_vm.idcard_a,
                            },
                            attrs: {
                              action: "#",
                              "on-preview": _vm.onHandlePictureCardPreview,
                              "file-list": _vm.idcard_a,
                              "list-type": "picture-card",
                              "http-request": (data) =>
                                _vm.onHandleUploadFile(data, "idcard_a"),
                              "before-remove": () =>
                                _vm.onHandleDeleteFile("idcard_a"),
                              limit: 1,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              attrs: { slot: "trigger" },
                              slot: "trigger",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "持卡人身份证人像页",
                          prop: "idcard_b",
                        },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.uploadLoading,
                                expression: "uploadLoading",
                              },
                            ],
                            class: {
                              hide: _vm.idcard_b.length || !_vm.idcard_b,
                            },
                            attrs: {
                              action: "#",
                              "on-preview": _vm.onHandlePictureCardPreview,
                              "file-list": _vm.idcard_b,
                              "list-type": "picture-card",
                              "http-request": (data) =>
                                _vm.onHandleUploadFile(data, "idcard_b"),
                              "before-remove": () =>
                                _vm.onHandleDeleteFile("idcard_b"),
                              limit: 1,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              attrs: { slot: "trigger" },
                              slot: "trigger",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "持卡人姓名", prop: "idcard_name" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.closeDisable || _vm.isEdit,
                                placeholder: "请输入持卡人姓名",
                                clearable: "",
                              },
                              model: {
                                value: _vm.cityForm.idcard_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "idcard_name", $$v)
                                },
                                expression: "cityForm.idcard_name",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "持卡人身份证号", prop: "idcard_code" },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.closeDisable || _vm.isEdit,
                                placeholder: "请输入持卡人身份证号",
                                clearable: "",
                              },
                              model: {
                                value: _vm.cityForm.idcard_code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "idcard_code", $$v)
                                },
                                expression: "cityForm.idcard_code",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "预留电话", prop: "bank_mobile" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.closeDisable || _vm.isEdit,
                                placeholder: "请输入预留电话",
                                maxlength: "11",
                                clearable: "",
                              },
                              model: {
                                value: _vm.cityForm.bank_mobile,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "bank_mobile", $$v)
                                },
                                expression: "cityForm.bank_mobile",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "服务区域", prop: "area_list" } },
                      [
                        _c("div", { staticClass: "d-flex a-center" }, [
                          _c(
                            "div",
                            { staticClass: "mr-15" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.closeDisable,
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "选择省",
                                  },
                                  on: { change: _vm.changeProvinceList },
                                  model: {
                                    value: _vm.cityForm.province_code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.cityForm,
                                        "province_code",
                                        $$v
                                      )
                                    },
                                    expression: "cityForm.province_code",
                                  },
                                },
                                _vm._l(_vm.province_list, function (item) {
                                  return _c("el-option", {
                                    key: item.area_code,
                                    attrs: {
                                      label: item.name,
                                      value: item.area_code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mr-15" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.closeDisable,
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "选择市",
                                  },
                                  on: { change: _vm.changeCityList },
                                  model: {
                                    value: _vm.cityForm.city_code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.cityForm, "city_code", $$v)
                                    },
                                    expression: "cityForm.city_code",
                                  },
                                },
                                _vm._l(_vm.city_list, function (item) {
                                  return _c("el-option", {
                                    key: item.area_code,
                                    attrs: {
                                      label: item.name,
                                      value: item.area_code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.closeDisable,
                                    clearable: "",
                                    filterable: "",
                                    multiple: "",
                                    placeholder: "选择区",
                                  },
                                  model: {
                                    value: _vm.cityForm.area_list,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.cityForm, "area_list", $$v)
                                    },
                                    expression: "cityForm.area_list",
                                  },
                                },
                                _vm._l(_vm.district_list, function (item) {
                                  return _c("el-option", {
                                    key: item.area_code,
                                    attrs: {
                                      label: item.name,
                                      value: item.area_code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "区域经理",
                          prop: "regional_manager_id",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              disabled: _vm.closeDisable,
                              clearable: "",
                              filterable: "",
                              placeholder: "选择区域经理",
                            },
                            model: {
                              value: _vm.cityForm.regional_manager_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cityForm,
                                  "regional_manager_id",
                                  $$v
                                )
                              },
                              expression: "cityForm.regional_manager_id",
                            },
                          },
                          _vm._l(_vm.managerListData, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.fullname, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "区域总人口",
                          prop: "regional_user_num",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex a-center" },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.closeDisable,
                                placeholder: "请输入区域总人口",
                                clearable: "",
                              },
                              on: {
                                blur: () => {
                                  _vm.cityForm.regional_user_num =
                                    _vm.cityForm.regional_user_num == 0
                                      ? ""
                                      : _vm.cityForm.regional_user_num
                                },
                              },
                              model: {
                                value: _vm.cityForm.regional_user_num,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cityForm,
                                    "regional_user_num",
                                    $$v
                                  )
                                },
                                expression: "cityForm.regional_user_num",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "ml10",
                                staticStyle: {
                                  color: "#333333",
                                  width: "80px",
                                  "text-align": "left",
                                },
                              },
                              [_vm._v(" 万人 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "仓覆盖人口",
                          prop: "coverage_user_num",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex a-center" },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.closeDisable,
                                placeholder: "请输入仓覆盖人口",
                                clearable: "",
                              },
                              on: {
                                blur: () => {
                                  _vm.cityForm.coverage_user_num =
                                    _vm.cityForm.coverage_user_num == 0
                                      ? ""
                                      : _vm.cityForm.coverage_user_num
                                },
                              },
                              model: {
                                value: _vm.cityForm.coverage_user_num,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cityForm,
                                    "coverage_user_num",
                                    $$v
                                  )
                                },
                                expression: "cityForm.coverage_user_num",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "ml10",
                                staticStyle: {
                                  color: "#333333",
                                  width: "80px",
                                  "text-align": "left",
                                },
                              },
                              [_vm._v(" 万人 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "签约状态", prop: "contract_status" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.closeDisable,
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "选择签约状态",
                                },
                                model: {
                                  value: _vm.cityForm.contract_status,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.cityForm,
                                      "contract_status",
                                      $$v
                                    )
                                  },
                                  expression: "cityForm.contract_status",
                                },
                              },
                              _vm._l(_vm.SIGN_STATUS_ENUM, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "xx天不发车停车整改",
                          prop: "stop_logistics_day",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex a-center" },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.closeDisable,
                                placeholder: "请输入",
                                clearable: "",
                              },
                              model: {
                                value: _vm.cityForm.stop_logistics_day,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cityForm,
                                    "stop_logistics_day",
                                    $$v
                                  )
                                },
                                expression: "cityForm.stop_logistics_day",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "ml10",
                                staticStyle: {
                                  color: "#333333",
                                  width: "80px",
                                  "text-align": "left",
                                },
                              },
                              [_vm._v(" 天 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "保证金", prop: "earnest_money" } },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex a-center" },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.closeDisable,
                                placeholder: "请输入保证金",
                                clearable: "",
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.BlurEarnestMoney()
                                },
                              },
                              model: {
                                value: _vm.cityForm.earnest_money,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "earnest_money", $$v)
                                },
                                expression: "cityForm.earnest_money",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "ml10",
                                staticStyle: {
                                  color: "#333333",
                                  width: "80px",
                                  "text-align": "left",
                                },
                              },
                              [_vm._v(" 元 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "保证金转账记录", prop: "earnest_url" },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.uploadLoading,
                                expression: "uploadLoading",
                              },
                            ],
                            class: {
                              hide: _vm.earnest_url.length || !_vm.earnest_url,
                            },
                            attrs: {
                              action: "#",
                              "on-preview": _vm.onHandlePictureCardPreview,
                              "file-list": _vm.earnest_url,
                              "list-type": "picture-card",
                              "http-request": (data) =>
                                _vm.onHandleUploadFile(data, "earnest_url"),
                              "before-remove": () =>
                                _vm.onHandleDeleteFile("earnest_url"),
                              limit: 1,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              attrs: { slot: "trigger" },
                              slot: "trigger",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "运距", prop: "shipment_distance" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              staticClass: "distance-style",
                              attrs: {
                                disabled: _vm.isEdit || _vm.closeDisable,
                                placeholder: "请输入运距",
                                clearable: "",
                              },
                              on: {
                                blur: () =>
                                  (_vm.cityForm.shipment_distance =
                                    _vm.utilsTool.filterUnNumber(
                                      _vm.cityForm.shipment_distance
                                    )),
                              },
                              model: {
                                value: _vm.cityForm.shipment_distance,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cityForm,
                                    "shipment_distance",
                                    $$v
                                  )
                                },
                                expression: "cityForm.shipment_distance",
                              },
                            }),
                            _vm._v(" 公里 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "d-flex mb-10" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "170px",
                            "text-align": "right",
                          },
                        },
                        [_vm._v("在途时间：")]
                      ),
                      _vm._v(" " + _vm._s(_vm.trans_time) + " "),
                    ]),
                    _c("div", { staticClass: "d-flex mb-10" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "170px",
                            "text-align": "right",
                          },
                        },
                        [_vm._v("定位地址：")]
                      ),
                      _vm._v(" " + _vm._s(_vm.address) + " "),
                    ]),
                  ],
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              !_vm.closeDisable
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.submitLoading },
                      on: { click: _vm.onHandleSubmit },
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "登录密码已重置",
            visible: _vm.newPassword,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "30%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.newPassword = $event
            },
            close: _vm.onHandleClosePassword,
          },
        },
        [
          _c("div", { staticClass: "contents" }, [
            _c("div", { staticClass: "mb-10" }, [
              _vm._v("登录账户：" + _vm._s(_vm.cityForm.account_number)),
            ]),
            _c("div", { staticClass: "mb-25 d-flex a-center" }, [
              _vm._v(" 重置密码：" + _vm._s(_vm.newPasswordText) + " "),
              _c(
                "div",
                { staticStyle: { "margin-left": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onHandleCopy },
                    },
                    [_vm._v("复制")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClosePassword } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onHandleClosePassword },
                },
                [_vm._v(" 关闭 ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }